import { render, staticRenderFns } from "./UpdateImage.vue?vue&type=template&id=7012a736&scoped=true"
import script from "./UpdateImage.vue?vue&type=script&lang=js"
export * from "./UpdateImage.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=7012a736&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7012a736",
  null
  
)

export default component.exports